import { QueryComment } from 'generated/graphql';
import React, { useState } from 'react';
import { useStyles } from './CommentText.jss';
import { Text } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';

export type CommentTextProps = {
  comment: Pick<QueryComment, 'id' | 'commentText'>;
  maxCaracteres: number;
  maxLines: number;
};

export const CommentText: React.FC<CommentTextProps> = ({ comment, maxCaracteres, maxLines }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openedComments, setOpenedComments] = useState<string[]>(['']);
  const exceedsMaxLines = comment.commentText.split(/\r\n|\r|\n/).length > maxLines;
  const exceedsMaxCarcateres = comment.commentText.length > maxCaracteres;

  const addOpenedComment = (id: string) => {
    return openedComments.concat(id);
  };

  const removeClosedComment = (id: string) => {
    return openedComments.filter((openedComments) => openedComments !== id);
  };

  const onReadMoreClick = (id: string) => {
    setOpenedComments(addOpenedComment(id));
  };

  const onReadLessClick = (id: string) => {
    setOpenedComments(removeClosedComment(id));
  };

  const getTruncatedText = () => {
    return (
      comment.commentText
        .split(/\r\n|\r|\n/)
        .splice(0, maxLines)
        .join('\n')
        .slice(0, maxCaracteres) + ' '
    );
  };

  return (
    <div data-testid="timeline-item-details" className={classes.commentStyle}>
      {!exceedsMaxLines && !exceedsMaxCarcateres ? (
        comment.commentText
      ) : openedComments.some((openedComments) => openedComments.includes(comment.id)) ? (
        <>
          {comment.commentText + '\n'}
          <Text className={classes.truncateAndCollapse} onClick={() => onReadLessClick(comment.id)}>
            {t('display-query-comments-text-truncate')}
          </Text>
        </>
      ) : (
        <>
          {getTruncatedText()}
          <Text className={classes.truncateAndCollapse} onClick={() => onReadMoreClick(comment.id)}>
            {t('display-query-comments-text-collapse')}
          </Text>
        </>
      )}
    </div>
  );
};
